<template lang="html">

  <article class="noticia-el row-center ais" :destacada="destacada">


    <div class="contenedor-imagen">

      <img src="/static/img/imagen-home-togo.jpg" alt="imagen-home">
      
    </div>

    <div class="contenedor-texto">
      <h3 class="fecha">{{ formatDate }}</h3>
      <h2>{{data.title}}</h2>
      <p>{{data.header}}</p>
      <router-link :to="$t('enlaces.noticia')+'/'+data.slug" class="btn with-border">Leer noticia</router-link>
    </div>
      
    <router-link :to="$t('enlaces.noticia')+'/'+data.slug" class="enlace-cover"></router-link>

  </article>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'noticia',
    props: ['data','destacada'],
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      }),
      formatDate () {
        const rawDate = this.data.created_at;
        if (!rawDate) return '';

        const date = new Date(rawDate);
        if (Number.isNaN(date.getTime())) return rawDate;

        return new Intl.DateTimeFormat('es-ES', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(date);
      }
    }
}
</script>

<style scoped lang="scss">
  .noticia-el {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/noticia-el.vue